import IconBase from "./IconBase";

// A schema tree: one parent type branching into its fields. A content model is
// structure, so the glyph shows structure rather than a generic shape.
const ContentModelIcon = (props) => (
    <IconBase {...props}>
        <rect x="9" y="2.5" width="6" height="6" rx="2" />
        <rect x="2.5" y="15.5" width="6" height="6" rx="2" />
        <rect x="15.5" y="15.5" width="6" height="6" rx="2" />
        <path d="M12 8.5V12" />
        <path d="M5.5 15.5V12H18.5V15.5" />
    </IconBase>
);

export default ContentModelIcon;
